import { useActiveStepContext } from 'src/components/context/ActiveStepContext';
import ChooseAvailabilitySelect from 'src/pages/SelectAvailability/Components/ChooseAvailabilitySelect';
import SelectResidentAvailability from 'src/pages/SelectAvailability/Components/SelectResidentAvailability';

const SelectAvailability = () => {
  const { activeStep } = useActiveStepContext();
  if (activeStep === 'step_1') {
    return <ChooseAvailabilitySelect />;
  }
  if (activeStep === 'step_2') {
    return <SelectResidentAvailability />;
  }
  return null;
};

export default SelectAvailability;
